import * as React from "react";
import type { SVGProps } from "react";
const SvgGuideIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="guide_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M256 149.333a85.333 85.333 0 0 0-85.333 85.334v449.792c17.92-8.022 37.76-12.459 58.666-12.459h624V234.667A85.333 85.333 0 0 0 768 149.333H256zM229.333 960a144 144 0 0 1-143.53-132.352 43.05 43.05 0 0 1-.47-6.315V234.667A170.667 170.667 0 0 1 256 64h512a170.667 170.667 0 0 1 170.667 170.667v480A42.667 42.667 0 0 1 896 757.333H229.333a58.667 58.667 0 1 0 0 117.334H768A42.667 42.667 0 1 1 768 960H229.333z"
    />
    <path
      fill="currentColor"
      d="M444.672 302.379c4.224-12.587 22.101-28.032 51.157-30.123 26.539-1.92 54.358 8.533 71.467 37.12 9.045 15.061 10.837 26.965 9.984 36.352-.896 9.813-5.12 20.01-12.8 30.55-16.128 21.93-43.648 39.68-64.683 48.725a38.4 38.4 0 1 0 30.251 70.613c28.715-12.33 69.461-37.248 96.341-73.941 13.824-18.774 24.832-41.942 27.35-68.822 2.56-27.306-4.011-55.381-20.566-82.986-34.048-56.747-91.605-77.952-142.933-74.24-48.81 3.541-101.29 31.104-118.443 82.474a38.4 38.4 0 0 0 72.875 24.32zM512.085 608a42.667 42.667 0 1 0 0-85.333 42.667 42.667 0 0 0 0 85.333z"
    />
  </svg>
);
export default SvgGuideIcon;
